/* ==========================================================================
   MIDNIGHT DOCK — interactions
   Lamp-string navigation (tabs) + tide clock. Re-binds on theme-editor reload.
   ========================================================================== */
(() => {
  'use strict';

  /* ---------------------------------------------------- lamp navigation -- */

  function initLampNav(root) {
    root.querySelectorAll('[data-md-lights]').forEach((group) => {
      if (group.dataset.mdBound === 'true') return;
      group.dataset.mdBound = 'true';

      const lamps = Array.from(group.querySelectorAll('[data-md-lamp]'));
      const panels = Array.from(group.querySelectorAll('[data-md-panel]'));
      if (!lamps.length) return;

      const select = (key, focus) => {
        lamps.forEach((lamp) => {
          const on = lamp.dataset.mdLamp === key;
          lamp.classList.toggle('is-active', on);
          lamp.setAttribute('aria-selected', on ? 'true' : 'false');
          lamp.tabIndex = on ? 0 : -1;
        });
        panels.forEach((panel) => {
          const on = panel.dataset.mdPanel === key;
          panel.classList.toggle('is-active', on);
          panel.hidden = !on;
        });
        if (focus) {
          const active = lamps.find((l) => l.dataset.mdLamp === key);
          if (active) active.focus();
        }
      };

      lamps.forEach((lamp, index) => {
        lamp.addEventListener('click', () => select(lamp.dataset.mdLamp, false));
        lamp.addEventListener('keydown', (event) => {
          const step = event.key === 'ArrowRight' ? 1 : event.key === 'ArrowLeft' ? -1 : 0;
          if (!step) return;
          event.preventDefault();
          const next = lamps[(index + step + lamps.length) % lamps.length];
          select(next.dataset.mdLamp, true);
        });
      });

      const initial = lamps.find((l) => l.classList.contains('is-active')) || lamps[0];
      select(initial.dataset.mdLamp, false);
    });
  }

  /* -------------------------------------------------------- tide clock -- */

  // Four quayside tide states. angle is degrees clockwise from 12 o'clock.
  const TIDES = [
    { angle: 0,   time: '03:12', label: 'High water',  note: 'Best catch window — boats land on the top of the tide.' },
    { angle: 96,  time: '06:40', label: 'Slack tide',  note: 'Water stills. Ideal for oysters and shellfish.' },
    { angle: 186, time: '09:55', label: 'Low water',   note: 'Reef and urchin grounds exposed and workable.' },
    { angle: 288, time: '13:20', label: 'Flood tide',  note: 'Fish move in with the push. Prime for line catch.' }
  ];

  function initTide(root) {
    root.querySelectorAll('[data-md-tide]').forEach((clock) => {
      if (clock.dataset.mdBound === 'true') return;
      clock.dataset.mdBound = 'true';

      const needle = clock.querySelector('[data-md-tide-needle]') || clock.querySelector('.md-tide__needle');
      const timeEl = clock.querySelector('[data-md-tide-time]');
      const labelEl = clock.querySelector('[data-md-tide-label]');
      const noteEl = clock.querySelector('[data-md-tide-note]');
      let index = Number(clock.dataset.mdStart || 0) % TIDES.length;

      const render = () => {
        const tide = TIDES[index];
        if (needle) needle.style.transform = `rotate(${tide.angle}deg)`;
        if (timeEl) timeEl.textContent = tide.time;
        if (labelEl) labelEl.textContent = tide.label;
        if (noteEl) noteEl.textContent = tide.note;
      };

      const advance = () => { index = (index + 1) % TIDES.length; render(); };

      clock.addEventListener('click', advance);
      clock.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        advance();
      });
      render();
    });
  }

  /* ------------------------------------------------------ boot / rebind -- */

  function init(root) {
    initLampNav(root);
    initTide(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
